import {
  Component,
  computed,
  inject,
  input,
  OnInit,
  EventEmitter,
  Output,
  signal,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { InputOtpModule } from 'primeng/inputotp';
import { TranslateModule } from '@ngx-translate/core';
import {
  AutoUnsubscribe,
  ENVIRONMENT,
  Environment,
} from 'libs/core/src/public-api';
import { interval, Subscription } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-otp-code',
  templateUrl: './otp-code.component.html',
  imports: [InputOtpModule, TranslateModule, ReactiveFormsModule],
})
@AutoUnsubscribe('subs')
export class OtpCodeComponent implements OnInit, AfterViewInit {
  environment = inject<Environment>(ENVIRONMENT);
  subs = new Subscription();

  // Input for FormControl
  control = input.required<FormControl>();
  @ViewChild('code', { read: ElementRef }) code!: ElementRef;
  @Output() handleExpired = new EventEmitter<void>();
  timerValue = signal<number | undefined>(undefined);
  formattedTimerValue = computed(() => {
    return this.timerValue()
      ? this.formatTimerValue(this.timerValue()!)
      : undefined;
  });

  ngOnInit() {
    this.setTimer();
  }

  ngAfterViewInit() {
    const inputElement = this.code.nativeElement.querySelector('input');
    inputElement?.focus();
  }

  setTimer() {
    this.timerValue.set(this.environment.OTP_EXPIRATION_SECONDS);
    this.subs.add(
      interval(1000).subscribe({
        next: () => {
          this.timerValue.set(this.timerValue()! - 1);
          if (this.timerValue() === 0) {
            this.clearTimer();
            this.handleExpired.emit();
          }
        },
      }),
    );
  }

  clearTimer() {
    this.subs.unsubscribe();
    this.timerValue.set(undefined);
  }

  formatTimerValue(value: number): string {
    const minutes = Math.floor(value / 60);
    const seconds = value % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
}
